import { render, staticRenderFns } from "./MainDeposit.vue?vue&type=template&id=8df7cde8&scoped=true&"
import script from "./MainDeposit.vue?vue&type=script&lang=ts&"
export * from "./MainDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./MainDeposit.vue?vue&type=style&index=0&id=8df7cde8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df7cde8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/gubuy/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout})
